<template>
  <el-image class="_imgs" :src="src" :fit="fit">
    <template #placeholder>
      <div></div>
    </template>
    <template #error>
      <div></div>
    </template>
  </el-image>
</template>
<script setup>
const props = defineProps({
  src: {
    type: String,
    default: ''
  },
  fit: {
    type: String,
    default: '' // 'fill', 'contain','cover', 'none','scale-down',
  },
  lazy: Boolean,
})
</script>
<style lang="scss" scoped>
._imgs {
  width: inherit;
  height: inherit;
  display: flex;
  align-items: center;
}
</style>